import { inject, Injectable } from '@angular/core';
import { AttachmentApi } from '../api/attachment-api';
import { Attachment } from '../models/attachment/attachment';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AttachmentRepository {
  private attachmentApi = inject(AttachmentApi);

  public uploadAttachmentFile(attachment: Attachment, file: File): Observable<HttpResponse<unknown>> {
    return this.attachmentApi.uploadAttachmentFile(attachment, file);
  }
}
